<template>
  <div id="app">
    <router-view v-if="isRouter" />
  </div>
</template>

<script>
  export default {
    name: 'App',
    data() {
      return {
        isRouter: false
      }
    },
    beforeMount() {
      // https://www.isunon.com
      this.$store.dispatch('getBaseDataRouter').then(res => {
        // console.log(res)
        this.isRouter = true
      })
    },
    // beforeCreate() {
      // this.$store.dispatch('getBaseDataRouter')
    // },
    // created() {
      // this.$store.dispatch('getBaseDataRouter')
    // }
  }
</script>

<style>
  #app {
    background-color: white;
    height: 100%;
    font-family: -apple-system, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei UI", "Microsoft YaHei", "Source Han Sans CN", sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #5B5B5B;
    font-size: .875rem;
    line-height: 1.4;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue